/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Radio } from 'antd';
import 'antd/dist/antd.css';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { RightOutlined } from '@ant-design/icons';
import { CreateAccountHeader, RegionFlag } from '..';
import ConfirmButton from './buttons/ConfirmButton';
import { InviteHeader, RadioButtonRegion, RadioButtonRegionText } from '../Forms';

const UsInvitation = ({ companyName, setStep, regionFormConfig }) => {
  const { t } = useTranslation();
  const region = regionFormConfig.code;

  return (
    <>
      <CreateAccountHeader
        company={companyName}
        descLabel={t(`FORM_USER_ACCOUNT.USER_ACCOUNT_DESC_${region}`)}
        regionFormConfig={regionFormConfig}
        detail={false}
      />
      <Row align="middle" justify="center" gutter={32} style={{ marginTop: '15px', marginBottom: '35px' }}>
        <Col span={2} />
        <Col span={20}>
          <div className="site-card-border-less-wrapper">
            <Row align="middle" type="flex">
              <Col span={24}>
                <InviteHeader>{t(`FORM_USER_ACCOUNT.OPERATIONS_LOCATION_${region}`)}</InviteHeader>
              </Col>
            </Row>
            <Row align="middle" justify="center">
              <Radio.Group defaultValue={regionFormConfig.fields.regions.defaultValue} style={{ width: '100%' }}>
                <Row justify="space-evenly">
                  {Object.values(regionFormConfig.fields.regions.invitationValues).map(({ code, disabled }) => (
                    <RadioButtonRegion value={code} disabled={disabled}>
                      <Row align="middle">
                        <Col span={11}>
                          <Row>
                            <RegionFlag region={code} />
                          </Row>
                        </Col>
                        <Col span={13}>
                          <Row>
                            <RadioButtonRegionText>
                              {t(`FORM_USER_ACCOUNT.REGION_${code}`)}
                            </RadioButtonRegionText>
                          </Row>
                        </Col>
                      </Row>
                    </RadioButtonRegion>
                  ))}
                </Row>
              </Radio.Group>
            </Row>
            <Row
              justify="center"
              style={{
                marginTop: '25px',
                marginBottom: '15px',
              }}
            >
              <Col span={14}>
                <ConfirmButton disabled execute={() => setStep()} icon={<RightOutlined />} />
              </Col>
            </Row>
          </div>

        </Col>
        <Col span={2} />
      </Row>
    </>
  );
};

UsInvitation.propTypes = {
  companyName: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  regionFormConfig: PropTypes.any.isRequired,
};

export default UsInvitation;
